import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Notes App',
        projectDesc: 'This is notes web application where we can store our daily todolist. It helps us add and remove the feature the task which is done and we can set a remainder that the task shown in our pending list.',
        tags: ['HTML' ,'CSS', 'Javascript'],
        code: 'https://github.com/PrinceKumawat1109/Notes-App.git',
        demo: 'https://todo-notesapp.netlify.app/',
        image: "https://i.ibb.co/hRcfDWt/notesoutput.png"
    },
    {
        id: 2,
        projectName: 'Joke Generator',
        projectDesc: 'This is a Joke Generator application where we can relaxed out for 5 to 10 minutes. This will generate the jokes randomly.',
        tags: ['HTML', 'CSS','Javascript'],
        code: 'https://github.com/PrinceKumawat1109/Joke-Generator.git',
        demo: 'https://fulljokegenerator.netlify.app/',
        image: "https://i.ibb.co/BrSVFTR/jokeoutput.png"
    },
    {
        id: 3,
        projectName: 'Text Analyser',
        projectDesc: 'The text analyser is the wonderful part of my skill learning. It determine the count of all the letters, text, words, digits, capital letters, small letters, symbols, sentences, vowels and consonants were used.',
        tags: ['HTML', 'CSS','Javascript'],
        code: 'https://github.com/PrinceKumawat1109/Text-Analyzer.git',
        demo: 'https://text-analyser01.netlify.app/',
        image: "https://i.ibb.co/p0NrGgy/textouput.png"
    },
    {
        id: 4,
        projectName: 'Live Clock',
        projectDesc: 'This is the simple live clock which will show the current time as your present location.',
        tags: ['CSS','Javascript'],
        code: 'https://github.com/PrinceKumawat1109/Clock.git',
        demo: 'https://live-clock-js.netlify.app/',
        image: "https://i.ibb.co/YcwrkVR/clockoutput.png"
    },
    // {
    //     id: 5,
    //     projectName: 'Reliance Digital Clone - Frontend',
    //     projectDesc: 'This project is the clone of Reliance Digital built as a part of a project week. It simulates the functionality of an e-commerce website from landing page to checkout. My contribution was the product catalog page arriving from the navbar, as well as leading the team.',
    //     tags: ['HTML', 'CSS', 'Javascript'],
    //     code: 'https://github.com/iamrituyadav/Reliance_digital',
    //     demo: 'https://reliance-digital-clone.herokuapp.com/',
    //     image: "https://miro.medium.com/max/875/1*qRNfRbuHCDC1ct0chLZoWA.png"
    // },
    
]

